import { render, staticRenderFns } from "./MdmRadio.vue?vue&type=template&id=342d318e&scoped=true&name=mdm-radio&"
import script from "./MdmRadio.vue?vue&type=script&lang=js&"
export * from "./MdmRadio.vue?vue&type=script&lang=js&"
import style0 from "./MdmRadio.vue?vue&type=style&index=0&id=342d318e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342d318e",
  null
  
)

export default component.exports